import styled from 'styled-components';

const Gradient = styled.div`
  position: absolute;
  bottom: 0;
  height: 200px;
  width: 100%;
  background: linear-gradient(rgba(39, 50, 57, 0), rgb(39, 50, 57) 70%);
`;

export default Gradient;
